import { Button, Flex, Statistic } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { OrderListResponse } from "../../../../hooks/Order/data";
import useGetTimezone from "../../../../hooks/Timezone/timezone.hooks";
import { envChangeType, envType } from "../../../../plugins/utils";

type ButtonContinuePayProps = {
  item: OrderListResponse;
  handleCheckout: (item: OrderListResponse) => void;
  loading: boolean;
};

const ButtonContinuePay: React.FC<ButtonContinuePayProps> = ({
  handleCheckout,
  item,
  loading,
}) => {
  const { t } = useTranslation();
  const { Countdown } = Statistic;
  const { toLocalTimezone } = useGetTimezone();
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [now, setNow] = useState<Dayjs | null>(toLocalTimezone(dayjs()));
  const [paymentDeadline, setPaymentDeadline] = useState<Dayjs | null>();
  const [paymentDelay, setPaymentDelay] = useState<Dayjs | null>();

  const getPaymentDeadline = (_item: OrderListResponse) => {
    if (!_item) return;
    const tomorrow = now?.add(1, "day");
    const startDate = toLocalTimezone(_item?.order_details[0]?.start_date);
    // 判断 startDate 是否是明天

    const isStartDateTomorrow = startDate?.isSame(tomorrow, "day");

    const createDate = toLocalTimezone(_item?.created_at);
    // 前台訂單2小時, 客製化課程/補單8小時
    const countdownEnd = createDate?.add(_item?.payment_expire_hours ?? 2, "hour");

    const limitHour = envChangeType(
      "REACT_APP_LIMIT_NEXT_DAY_ORDER",
      envType.NUMBER
    );
    const sevenPmUtcPlus9 = createDate
      ?.hour(limitHour)
      .minute(0)
      .second(0)
      .millisecond(0);
    //TODO: Open when 7PM logic need to use
    const deadLine = isStartDateTomorrow
      ? countdownEnd?.isBefore(sevenPmUtcPlus9)
        ? countdownEnd
        : sevenPmUtcPlus9
      : countdownEnd;
    setPaymentDeadline(deadLine);
  };

  const getPaymentDelay = (_item: OrderListResponse) => {
    if (!_item.paid_at || _item.paid_at === null) {
      setPaymentDelay(now);
      return;
    }
    const payDate = toLocalTimezone(_item?.paid_at);
    const countdownEnd = payDate?.add(2, "minutes");
    setPaymentDelay(countdownEnd);
  };

  const onCountDownFinish = () => {
    const _now = toLocalTimezone(dayjs());
    setNow(_now);
    setIsDisabled(
      _now?.isAfter(paymentDeadline) || _now?.isBefore(paymentDelay) || false
    );
  };

  useEffect(() => {
    if (!item) return;
    getPaymentDeadline(item);
    getPaymentDelay(item);
  }, [item]);

  useEffect(() => {
    setIsDisabled(
      now?.isAfter(paymentDeadline) || now?.isBefore(paymentDelay) || false
    );
  }, [paymentDeadline, paymentDelay, now]);

  useEffect(() => {
    console.debug("isdisabled", isDisabled);
  }, [isDisabled]);

  useEffect(() => {
    console.debug(
      "now?.isAfter(paymentDeadline)",
      now?.isAfter(paymentDeadline)
    );
  }, [paymentDeadline, now]);

  useEffect(() => {
    console.debug("now?.isBefore(paymentDelay)", now?.isBefore(paymentDelay));
  }, [paymentDelay, now]);

  const render = useMemo(() => {
    return (
      <Button
        loading={loading}
        disabled={isDisabled}
        type="primary"
        style={{
          fontSize: "var(--fontSetting-middle)",
          height: 36,
        }}
        onClick={() => handleCheckout(item)}
      >
        {
          <Flex align="center" gap={10}>
            {now?.isBefore(paymentDelay)
              ? t("payment.delay")
              : t("record.continuePay")}
            <Countdown
              value={
                now?.isBefore(paymentDelay)
                  ? paymentDelay?.valueOf()
                  : paymentDeadline?.valueOf()
              }
              onFinish={onCountDownFinish}
            />
          </Flex>
        }
      </Button>
    );
  }, [now, paymentDeadline, paymentDelay, isDisabled]);
  return render;
};

export default ButtonContinuePay;
